<script>
import { mapGetters, mapActions } from "vuex";

import appStatuses from "../../service/contract-statuses";

import AppConfirm from "../../components/modals/app-confirm.vue";

import AdminContractPage from "../../components/AdminContractLotinPage.vue";

import AdminContractSchetSummPage from "~/src/components/AdminContractSchetSummLotinPage.vue";
import AdminContractSchetSummPagePechat from "~/src/components/AdminContractSchetSummLotinPagePechat.vue";
import AdminContractPaidShow2024 from "~/src/components/AdminContractPaidShow2024.vue";
import AdminContractPaidEdit2024 from "~/src/components/AdminContractPaidEdit2024.vue";
import AddGroupNumber2024 from "~/src/components/AddGroupNumber2024.vue";
import AdminContractPaidPayment2024 from "~/src/components/AdminContractPaidPayment2024.vue";
import EditContractNumber2024 from "~/src/components/EditContractNumber2024.vue";
import AdminAddPromotion2024 from "~/src/components/AdminAddPromotion2024.vue";
import axios from 'axios'
import { loadDraft, saveTab, loadTab } from "~/src/utils/contract-edit-draft";
import { readableTextOn } from "~/src/utils/readable-text";

export default {
  components: {
    AdminContractSchetSummPage,
    AdminContractSchetSummPagePechat,
    AdminContractPaidShow2024,
    AppConfirm,
    AdminContractPage,
    AdminContractPaidEdit2024,
    AddGroupNumber2024,
    AdminContractPaidPayment2024,
    EditContractNumber2024,
    AdminAddPromotion2024,
  },

  data: () => ({
    tabs: {
      personal: "Personal info",
      edit: "Edit",
      payment: "Payment",
      groupAdd: "Add Group Number",
      editContractNumber: "Contract Number",
      promotion: "VAUCHER",
    },

    tab: "Personal info",

    loading: false,

    deleteDialog: false,

    isContract: false,

    isInvoice: false,

    isInvoicePechat: false,

    pdfData: null,
    canExport: false,
    canDelete: false,
    canUpdate: false
  }),

  async mounted() {
    this.canExport = await this.hasRole("KONTRAKT_24_25", "EXCEL");
    this.canDelete = await this.hasRole("KONTRAKT_24_25", "DELETE");
    this.canUpdate = await this.hasRole("KONTRAKT_24_25", "UPDATE");
  },

  computed: {
    ...mapGetters("admin-contracts2024", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,

    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSupperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
    isAccounter: (vm) => vm.user.role == "ACCOUNTER",
    isAccounterHelper: (vm) => vm.user.role == "ACCOUNTER_HELPER",
    isQabulQiluvchi: (vm) => vm.user.role == "QABUL_QILUVCHI",
    applicationStatus() {
      const status =
        appStatuses.find((x) => x.id == this.application.paidStatus) || {};

      return {
        name: status[`name-${this.$i18n.locale}`],
        color: color(status.id),
      };

      function color(statusName) {
        switch (statusName) {
          case "PAID":
            return "#26d317";
          case "HALF_PAID":
            return "#d8d813";
          case "NOT_PAID":
            return "#Fb0607";
          default:
            return null;
        }
      }
    },
  },

  created() {
    const id = this.$route.params.id;
    if (id != this.application.id) {
      this.INIT_BY_ID({ id }).then((status) => {
        if (!status) {
          this.$router.replace("/dashboard");
          return;
        }
        this.restoreDraft();
      });
    } else {
      this.restoreDraft();
    }
  },

  watch: {
    tab(v) { const id = this.application?.id; if (id) saveTab(2024, id, v); },
  },

  methods: {
    // Dark text on the light status fills (the "Qisman" yellow, the "To'liq" green), white on the rest.
    textOn: readableTextOn,

    ...mapActions("admin-contracts2024", ["INIT_BY_ID", "DELETE_APPLICATION"]),

    ...mapActions("admin-contract2024", [
      "INIT_APPLICATION",
      "INIT_HISTORY",
      "INIT_ADD_GROUP",
    ]),


    async restoreDraft() {
      const id = this.application?.id;
      if (!id) return;
      const draft = loadDraft(2024, id);
      const savedTab = loadTab(2024, id);
      if (draft) {
        await this.INIT_APPLICATION(draft);
        this.tab = this.tabs.edit;
      } else if (savedTab && Object.values(this.tabs).includes(savedTab)) {
        this.tab = savedTab;
        if (savedTab !== this.tabs.personal) {
          await this.INIT_APPLICATION(this.application);
        }
      }
    },
    async hasRole(panel, op) {
      try {
        const res = await axios.get(`/admin/panel-permissions/check`, {
          params: {appPanel: panel, op}
        });
        return res.data === true;
      } catch {
        return false;
      }
    },

    getVaucherText(promValue) {
      if (promValue <= 100) {
        return "Vaucher berilgan, miqdori: " + promValue + " %";
      } else {
        return "Vaucher berilgan, miqdori: " + promValue + " so'm";
      }
    },

    onEdit() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.edit;
      });
    },

    onPayment() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.payment;
      });
    },

    onPromotion() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.promotion;
      });
    },

    navigateToAdmin() {
      this.$router.go(-1);
    },

    onDelete() {
      this.loading = true;
      this.DELETE_APPLICATION(this.application).then((status) => {
        this.loading = false;
        if (status) {
          this.$router.replace("/contract_2024_2025");
        }
      });
    },

    onAddModel() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.groupAdd;
      });
    },

    onEditContractNumber() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.editContractNumber;
      });
    },

    async onDownloadContract() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract2024/invoice/${id}`);
      if (data) {
        this.pdfData = data;
        this.pdfData.contractId = id;
        this.$nextTick(() => (this.isContract = true));
      } else {
        this.loading = false;
      }
    },

    async onDownloadContractInvoice() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract2024/invoice/${id}`);
      if (data) {
        this.pdfData = data;
        this.pdfData.contractId = id;
        this.$nextTick(() => (this.isInvoice = true));
      } else {
        this.loading = false;
      }
    },

    async onDownloadContractInvoicePechat() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract2024/invoice/${id}`);
      if (data) {
        this.pdfData = data;
        this.pdfData.contractId = id;
        this.$nextTick(() => (this.isInvoicePechat = true));
      } else {
        this.loading = false;
      }
    },

    async generateContract(template_id) {
      const contractId = this.application?.id;
      if (!contractId) {
        this.$emit("error", "Contract ID not found.");
        return;
      }

       if (this.application.typeAbiturient === "MASTER") {
        template_id = 1100; 
      } else {
        template_id = 1000;
      }
      
      this.loadingId = template_id;

      try {
        const locale = this.$i18n.locale;
        const res = await axios.get(
          `/admin/contract2024/contract?contract_id=${contractId}&template_id=${template_id}&locale=${locale}`,
          { responseType: "blob" }
        );

        const blob = new Blob([res.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${this.application.firstName + " " + this.application.lastName + " " + this.application.middleName}.pdf`;
        link.click();
      } catch (e) {
        console.error(e);
        this.$emit("error", "Xatolik yuz berdi");
      } finally {
        this.loadingId = null;
      }
    },
  },
};
</script>

<template>
  <div class="pb-5">
    <admin-contract-page
      v-if="isContract && pdfData"
      :pdfData="pdfData"
      @close="
        () => {
          isContract = false;
          loading = false;
        }
      "
    />
    <admin-contract-schet-summ-page
      v-if="isInvoice && pdfData"
      :pdfData="pdfData"
      @close="
        () => {
          isInvoice = false;
          loading = false;
        }
      "
    />
    <admin-contract-schet-summ-page-pechat
      v-if="isInvoicePechat && pdfData"
      :pdf-data="pdfData"
      @close="
        () => {
          isInvoicePechat = false;
          loading = false;
        }
      "
    />

    <app-confirm
      v-model="deleteDialog"
      :text="$t('Do you really want to delete?')"
      @accept="onDelete"
    />

    <v-container style="display: flex;">
      <v-btn
          @click="navigateToAdmin"
          elevation="0"
          rounded
          large
          class="font-made modern-back-btn mb-6 px-6 py-3 d-flex align-center"
          style="
          border: 1px solid #e0e0e0;
          background: linear-gradient(135deg, #ffffff, #f9f9f9);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
          transition: all 0.25s ease;
        "
      >
        <v-icon
            left
            size="22"
            style="color:#0c0c0c; transition: transform 0.2s;"
            class="back-icon"
        >
          mdi-arrow-left
        </v-icon>
        <span
            class="font-weight-bold text-uppercase"
            style="letter-spacing:1px; font-size:14px; color:#0c0c0c;"
        >
          {{ $t("Back") }}
        </span>
      </v-btn>

      <div class="-status-wrap" style="width: 100%; height: 100%;">
        <div
          class="-status"
          :style="{ backgroundColor: applicationStatus.color, color: textOn(applicationStatus.color) }"
        >
          {{ application.kurs }} - {{ $t("kurs talabasi") }}, {{ $t("Status") }}:
          {{ applicationStatus.name }}, {{ $t("Kontract summasi") }}
          {{ $comma(application.totalSumma) }}, {{ $t("Qoldiq") }}
          {{ $comma(application.totalOstatok) }}
        </div>
      </div>
    </v-container>
    <div class="-status-wrap pb-5">
      <div
        :style="{ backgroundColor: 'green' }"
        v-if="application.promotion > 0"
        class="-status"
        v-text="getVaucherText(application.promotion)"
      />
    </div>

    <v-container class="-wrap">
      <div class="pa-5">
        <div header>
          <div class="title pb-2 text-center accent--text tab-title" v-text="$t(tab)" />

          <div class="title-actions pb-5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  elevation="0"
                  color="accent"
                  @click="tab = tabs.personal"
                  :outlined="tab != tabs.personal"
                  class="px-0"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon> mdi-badge-account-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Personal info") }}</span>
            </v-tooltip>

            <v-tooltip   v-if="canUpdate" bottom >
              <template v-slot:activator="{ on, attrs }">
                <v-btn

                  :disabled="loading"
                  large
                  color="accent"
                  @click="onEdit"
                  :outlined="tab != tabs.edit"
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                >
                  <v-icon> mdi-file-document-edit-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>

            <v-tooltip v-if="canUpdate" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  @click="onPayment"
                  :outlined="tab != tabs.payment"
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                >
                  <v-icon> mdi-credit-card-multiple </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Payment") }}</span>
            </v-tooltip>

            <v-tooltip
                v-if="canUpdate"
                bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  @click="onPromotion"
                  :outlined="tab != tabs.promotion"
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                >
                  <v-icon> mdi-credit-card-multiple </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("promotion") }}</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="canUpdate"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn

                  :disabled="loading"
                  large
                  color="accent"
                  @click="onAddModel"
                  :outlined="tab != tabs.groupAdd"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                >
                  <v-icon> mdi-plus </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Add Group Number") }}</span>
            </v-tooltip>
            <v-tooltip v-if="canUpdate" bottom >
              <template v-slot:activator="{ on, attrs }">
                <v-btn

                  :disabled="loading"
                  large
                  color="accent"
                  @click="onEditContractNumber"
                  :outlined="tab != tabs.editContractNumber"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                >
                  <v-icon> mdi-file-document-edit-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Edit Contract Number") }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="application.paidStatus !== 'PAID'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                  @click="onDownloadContract"
                >
                  <v-icon> mdi-file-check-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("download_сontract") }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="application.paidStatus !== 'PAID'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                  @click="onDownloadContractInvoice"
                >
                  <v-icon> mdi-alpha-r-circle-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("download_сontract_schet") }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="application.paidStatus !== 'PAID'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                  @click="onDownloadContractInvoicePechat"
                >
                  <v-icon> mdi-file-pdf-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("download_сontract_schet_pechat") }}</span>
            </v-tooltip>

            <v-tooltip  v-if="canDelete" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="red darken-2"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                  @click="deleteDialog = true"
                >
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }" v-if="application.paidStatus !== 'PAID'">
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                  @click="generateContract(1000)"
                >
                  <v-icon> mdi-file-pdf </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("download_сontract_schet_pechat") }}</span>
            </v-tooltip>
          </div>

          <div class="position-relative">
            <v-progress-linear
              top
              absolute
              :active="loading"
              indeterminate
              posi
            />
          </div>
          <div class="text-center">
            <img src="@/assets/icons/devider.svg" alt="" />
          </div>
        </div>

        <div body class="pt-5">
          <admin-contract-paid-show2024 v-if="tab == tabs.personal" />
          <admin-contract-paid-edit2024 v-else-if="tab == tabs.edit" />
          <add-group-number2024 v-else-if="tab == tabs.groupAdd" />
          <AdminContractPaidPayment2024 v-else-if="tab == tabs.payment" />
          <EditContractNumber2024 v-else-if="tab == tabs.editContractNumber" />
          <AdminAddPromotion2024 v-else-if="tab == tabs.promotion" />
        </div>
      </div>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
.-status-wrap {
  display: flex;
  justify-content: center;

  .-status {
    padding: 8px 5px;
    border-radius: 10px;
    margin-left: 35px;
    margin-right: 35px;
    width: 100%;
    text-align: center;
    cursor: default;
    font-size: 18px;
    color: white;
  }
}

.-wrap {
  background: rgba(154, 154, 154, 0.2);
  border-radius: 10px;

  .title-actions {
    .v-btn {
      min-width: 44px;
    }
  }
}

.modern-back-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
}

.modern-back-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.back-icon:hover {
  transform: translateX(-3px);
}
</style>
